import { AuthUser, LoginResponse } from '../model/User'

export const loginToAuth = (login: LoginResponse): AuthUser | null => {
  const { accessToken, dateFormatType, firstName, lastName, refreshToken, sessionId } = login
  if (accessToken && dateFormatType && firstName && lastName && refreshToken && sessionId) {
    return login as AuthUser
  }
  return null
}
